/* eslint-disable func-names */
import React, { Component } from "react";
import { connect } from "react-redux";
import { getTKT1BankBrands, updateTKT1BankBrand, createTKT1BankBrand } from '../actions';
import ScrollToTop from "react-scroll-to-top";
import Pagination from "../components/Pagination";
import { CONFIGS } from "../configs";
import { getTranslate, LANGUAGE_KEYS } from "../utils";
import queryString from 'query-string';
import {
  Badge,
  Button,
  Card,
  Form,
  Table,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  InputGroup,
  Modal,
  Image,
  Toast,
  ToastContainer
} from "react-bootstrap";
import { FaTimes, FaEye, FaEdit, FaTrash, FaCopy, FaExternalLinkAlt, FaPlus } from 'react-icons/fa';

class TKT1BankBrand extends Component {
  initQuery = {
    currentPage: 1,
    itemsPerPage: 20,
    sortBy: 'priority_order',
    sortOrder: 1,
    search: '',
    is_active: ''
  }

  initShowColumns = {
    logo: true,
    bank_name: true,
    bank_code: true,
    bin: true,
    short_name: true,
    vietnamese_name: true,
    english_name: true,
    swift_code: true,
    can_register_online: true,
    visa_card_cost: true,
    register_note: true,
    etsy_note: true,
    is_support_etsy: true,
    max_banks: true,
    max_visa_debit_cards: true,
    contact_person: true,
    priority_order: true,
    is_active: true,
    created_at: false
  }

  initColumnWidths = {
    logo: 100,
    bank_name: 200,
    bank_code: 120,
    bin: 100,
    short_name: 120,
    vietnamese_name: 150,
    english_name: 150,
    swift_code: 120,
    can_register_online: 150,
    visa_card_cost: 150,
    register_note: 200,
    etsy_note: 200,
    is_support_etsy: 120,
    max_banks: 120,
    max_visa_debit_cards: 150,
    contact_person: 150,
    priority_order: 120,
    is_active: 120,
    created_at: 120,
    actions: 100
  }

  constructor() {
    super();
    this.state = {
      query: this.initQuery,
      showColumns: this.initShowColumns,
      columnWidths: this.initColumnWidths,
      loading: false,
      showConfigModal: false,
      showEditModal: false,
      showViewModal: false,
      showCreateModal: false,
      selectedBankBrand: null,
      isEditMode: false,
      showToast: false,
      toastMessage: '',
      toastType: 'success',
      isResizing: false,
      resizingColumn: null,
      resizeStartX: null,
      resizeStartWidth: null,
      editFormData: {
        bank_name: '',
        bank_code: '',
        bin: '',
        short_name: '',
        logo: '',
        logo_alt_text: '',
        vietnamese_name: '',
        english_name: '',
        can_register_online: '',
        visa_card_cost: '',
        register_note: '',
        etsy_note: '',
        is_support_etsy: false,
        max_banks: '',
        max_visa_debit_cards: '',
        swift_code: '',
        contact_person: '',
        ninepay_vietinbank_connection: '',
        tags: '',
        display_name: '',
        priority_order: '',
        is_active: true
      }
    };
  }

  componentDidMount() {
    document.title = 'TKT1 Bank Brand';
    const queryStringFromUrl = window.location.search;
    const urlParams = new URLSearchParams(queryStringFromUrl);
    
    const hasUrlParams = queryStringFromUrl && queryStringFromUrl.length > 1;
    
    if (hasUrlParams) {
      const queryObject = queryString.parse(queryStringFromUrl);
      
      ['itemsPerPage', 'currentPage'].map(key => {
        if (queryObject[key]) {
          queryObject[key] = parseInt(queryObject[key])
        }
      })
      if (queryObject.sortOrder) {
        queryObject.sortOrder = parseInt(queryObject.sortOrder);
      }
      
      const viewConfig = JSON.parse(localStorage.getItem('TKT1BankBrand_ViewConfig'));
      const columnWidths = JSON.parse(localStorage.getItem('TKT1BankBrand_ColumnWidths'));
      
      const restoredQuery = {
        ...this.initQuery,
        ...queryObject
      };

      this.setState({
        query: restoredQuery,
        showColumns: {
          ...this.initShowColumns,
          ...(viewConfig || {})
        },
        columnWidths: {
          ...this.initColumnWidths,
          ...(columnWidths || {})
        }
      }, () => {
        const apiQuery = this.prepareApiQuery(this.state.query);
        this.props.getTKT1BankBrands(apiQuery);
      })
    } else {
      var query = JSON.parse(localStorage.getItem('tkt1_bank_brand_query'));
      var viewConfig = JSON.parse(localStorage.getItem('TKT1BankBrand_ViewConfig'));
      var columnWidths = JSON.parse(localStorage.getItem('TKT1BankBrand_ColumnWidths'));
      
      if (query) {
        const restored = {
          ...this.initQuery,
          ...query
        };
        restored.itemsPerPage = parseInt(restored.itemsPerPage || this.initQuery.itemsPerPage);
        restored.currentPage = parseInt(restored.currentPage || this.initQuery.currentPage);
        restored.sortOrder = parseInt(restored.sortOrder || this.initQuery.sortOrder);

        this.setState({
          query: restored,
          showColumns: {
            ...this.initShowColumns,
            ...(viewConfig || {})
          },
          columnWidths: {
            ...this.initColumnWidths,
            ...(columnWidths || {})
          }
        }, () => {
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1BankBrands(apiQuery);
        })
      } else {
        this.setState({
          query: this.initQuery,
          showColumns: {
            ...this.initShowColumns,
            ...(viewConfig || {})
          },
          columnWidths: {
            ...this.initColumnWidths,
            ...(columnWidths || {})
          }
        }, () => {
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1BankBrands(apiQuery);
        })
      }
    }

    // Add global mouse event listeners for column resizing
    document.addEventListener('mousemove', this.handleMouseMove);
    document.addEventListener('mouseup', this.handleMouseUp);
  }

  componentWillUnmount() {
    // Remove global mouse event listeners
    document.removeEventListener('mousemove', this.handleMouseMove);
    document.removeEventListener('mouseup', this.handleMouseUp);
  }

  handleChangeSearch = (e) => {
    this.setState({
      query: { ...this.state.query, search: e.target.value }
    })
  }

  handleClearSearch = () => {
    this.setState({
      query: { ...this.state.query, search: '' }
    }, () => {
      this.handleSearch();
    })
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearch();
    }
  }

  handleSelectSort = (e) => {
    const newQuery = { ...this.state.query, sortBy: e.target.value };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_bank_brand_query', JSON.stringify(newQuery));
    
    const trimmedQuery = {
      ...newQuery,
      search: this.state.query.search.trim(),
      is_active: this.state.query.is_active
    };
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    this.updateUrl(trimmedQuery);
    this.props.getTKT1BankBrands(apiQuery);
  }

  handleSelectSortOrder = (e) => {
    const newQuery = { ...this.state.query, sortOrder: parseInt(e.target.value) };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_bank_brand_query', JSON.stringify(newQuery));
    
    const trimmedQuery = {
      ...newQuery,
      search: this.state.query.search.trim(),
      is_active: this.state.query.is_active
    };
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    this.updateUrl(trimmedQuery);
    this.props.getTKT1BankBrands(apiQuery);
  }


  handleActiveStatusChange = (e) => {
    const newQuery = { ...this.state.query, is_active: e.target.value };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_bank_brand_query', JSON.stringify(newQuery));
    
    const trimmedQuery = {
      ...newQuery,
      search: this.state.query.search.trim(),
      is_active: newQuery.is_active
    };
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    this.updateUrl(trimmedQuery);
    this.props.getTKT1BankBrands(apiQuery);
  }

  handleColumnToggle = (columnKey) => {
    this.setState(prevState => {
      const newShowColumns = {
        ...prevState.showColumns,
        [columnKey]: !prevState.showColumns[columnKey]
      };
      
      localStorage.setItem('TKT1BankBrand_ViewConfig', JSON.stringify(newShowColumns));
      
      return { showColumns: newShowColumns };
    })
  }

  resetColumnWidths = () => {
    this.setState({
      columnWidths: this.initColumnWidths
    }, () => {
      localStorage.setItem('TKT1BankBrand_ColumnWidths', JSON.stringify(this.initColumnWidths));
    });
  }

  copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      console.log('Copied to clipboard:', text);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }

  // Column resize handlers
  handleMouseDown = (e, columnKey) => {
    e.preventDefault();
    e.stopPropagation();
    
    // Get the current column width and starting position
    const currentWidth = this.state.columnWidths[columnKey];
    const startX = e.clientX;
    
    this.setState({
      isResizing: true,
      resizingColumn: columnKey,
      resizeStartX: startX,
      resizeStartWidth: currentWidth
    });
  }

  handleMouseMove = (e) => {
    if (!this.state.isResizing || !this.state.resizingColumn) return;

    e.preventDefault();
    
    // Calculate the difference from the starting position
    const deltaX = e.clientX - this.state.resizeStartX;
    const newWidth = Math.max(50, this.state.resizeStartWidth + deltaX);
    
    this.setState(prevState => {
      const newColumnWidths = {
        ...prevState.columnWidths,
        [this.state.resizingColumn]: newWidth
      };
      
      // Save to localStorage
      localStorage.setItem('TKT1BankBrand_ColumnWidths', JSON.stringify(newColumnWidths));
      
      return { columnWidths: newColumnWidths };
    });
  }

  handleMouseUp = () => {
    this.setState({
      isResizing: false,
      resizingColumn: null,
      resizeStartX: null,
      resizeStartWidth: null
    });
  }

  // Modal handlers
  handleViewClick = (bankBrand) => {
    this.setState({
      showViewModal: true,
      selectedBankBrand: bankBrand,
      isEditMode: false
    });
  }

  handleEditClick = (bankBrand) => {
    this.setState({
      showEditModal: true,
      selectedBankBrand: bankBrand,
      isEditMode: true,
      editFormData: {
        bank_name: bankBrand.bank_name || '',
        bank_code: bankBrand.bank_code || '',
        bin: bankBrand.bin || '',
        short_name: bankBrand.short_name || '',
        logo: bankBrand.logo || '',
        logo_alt_text: bankBrand.logo_alt_text || '',
        vietnamese_name: bankBrand.vietnamese_name || '',
        english_name: bankBrand.english_name || '',
        can_register_online: bankBrand.can_register_online || '',
        visa_card_cost: bankBrand.visa_card_cost || '',
        register_note: bankBrand.register_note || '',
        etsy_note: bankBrand.etsy_note || '',
        is_support_etsy: bankBrand.is_support_etsy || false,
        max_banks: bankBrand.max_banks || '',
        max_visa_debit_cards: bankBrand.max_visa_debit_cards || '',
        swift_code: bankBrand.swift_code || '',
        contact_person: bankBrand.contact_person || '',
        ninepay_vietinbank_connection: bankBrand.ninepay_vietinbank_connection || '',
        tags: bankBrand.tags || '',
        display_name: bankBrand.display_name || '',
        priority_order: bankBrand.priority_order || '',
        is_active: bankBrand.is_active !== undefined ? bankBrand.is_active : true
      }
    });
  }

  handleCreateClick = () => {
    this.setState({
      showCreateModal: true,
      selectedBankBrand: null,
      isEditMode: false,
      editFormData: {
        bank_name: '',
        bank_code: '',
        bin: '',
        short_name: '',
        logo: '',
        logo_alt_text: '',
        vietnamese_name: '',
        english_name: '',
        can_register_online: '',
        visa_card_cost: '',
        register_note: '',
        etsy_note: '',
        is_support_etsy: false,
        max_banks: '',
        max_visa_debit_cards: '',
        swift_code: '',
        contact_person: '',
        ninepay_vietinbank_connection: '',
        tags: '',
        display_name: '',
        priority_order: '',
        is_active: true
      }
    });
  }

  handleFormChange = (field, value) => {
    this.setState(prevState => ({
      editFormData: {
        ...prevState.editFormData,
        [field]: value
      }
    }));
  }

  showToast = (message, type = 'success') => {
    this.setState({
      showToast: true,
      toastMessage: message,
      toastType: type
    });
    
    // Auto hide toast after 3 seconds
    setTimeout(() => {
      this.setState({ showToast: false });
    }, 3000);
  }

  handleSubmitEdit = async () => {
    try {
      this.setState({ loading: true });
      
      const { selectedBankBrand, editFormData } = this.state;
      
      console.log('Submitting form:', { isEditMode: this.state.isEditMode, editFormData });
      
      if (this.state.isEditMode) {
        // Update existing bank brand
        console.log('Updating bank brand:', selectedBankBrand._id, editFormData);
        await this.props.updateTKT1BankBrand(selectedBankBrand._id, editFormData);
        this.showToast('Cập nhật ngân hàng thành công!', 'success');
      } else {
        // Create new bank brand
        console.log('Creating bank brand:', editFormData);
        await this.props.createTKT1BankBrand(editFormData);
        this.showToast('Thêm ngân hàng mới thành công!', 'success');
      }
      
      // Refresh data
      const apiQuery = this.prepareApiQuery(this.state.query);
      await this.props.getTKT1BankBrands(apiQuery);
      
      // Close modals
      this.setState({
        showEditModal: false,
        showCreateModal: false,
        selectedBankBrand: null,
        isEditMode: false,
        loading: false
      });
      
      console.log('Bank brand saved successfully');
      
    } catch (error) {
      console.error('Error saving bank brand:', error);
      this.showToast('Có lỗi xảy ra khi lưu dữ liệu!', 'error');
      this.setState({ loading: false });
    }
  }

  handleCloseViewModal = () => {
    this.setState({
      showViewModal: false,
      selectedBankBrand: null,
      isEditMode: false
    });
  }

  handleCloseEditModal = () => {
    this.setState({
      showEditModal: false,
      showCreateModal: false,
      selectedBankBrand: null,
      isEditMode: false
    });
  }

  handleCloseCreateModal = () => {
    this.setState({
      showCreateModal: false,
      selectedBankBrand: null,
      isEditMode: false
    });
  }


  prepareApiQuery = (query) => {
    const { showColumns, search, is_active, show_sidebar, ...baseQuery } = query;
    const apiQuery = {
      ...baseQuery,
      search: search ? search.trim() : ''
    };
    
    if (is_active && is_active.trim()) {
      apiQuery.is_active = is_active;
    }
    
    return apiQuery;
  }

  handleChangeItemsPerPage = (e) => {
    const itemsPerPage = parseInt(e.target.value);
    const trimmedQuery = {
      ...this.state.query,
      itemsPerPage,
      currentPage: 1,
      search: this.state.query.search.trim(),
      is_active: this.state.query.is_active
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    
    this.setState({
      query: { ...this.state.query, itemsPerPage, currentPage: 1 }
    }, () => {
      this.updateUrl(trimmedQuery);
      this.props.getTKT1BankBrands(apiQuery);
      localStorage.setItem('tkt1_bank_brand_query', JSON.stringify(trimmedQuery));
    })
  }

  updateUrl = (query) => {
    const { history } = this.props;
    const { showColumns, show_sidebar, ...urlQuery } = query;
    
    const queryStr = queryString.stringify(urlQuery);

    history.push({
      pathname: '/admin/tkt1-bank/bank-brand',
      search: queryStr,
    });
  }

  handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.handleSearch();
  }

  handleSearch = () => {
    const trimmedQuery = {
      ...this.state.query,
      search: this.state.query.search.trim(),
      is_active: this.state.query.is_active
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    
    this.updateUrl(trimmedQuery)
    this.props.getTKT1BankBrands(apiQuery);
    localStorage.setItem('tkt1_bank_brand_query', JSON.stringify(trimmedQuery));
  }


  updatePage = (itemOffset, newPage) => {
    if (newPage == this.state.query.currentPage)
      return;

    const trimmedQuery = {
      ...this.state.query,
      currentPage: newPage,
      search: this.state.query.search.trim(),
      is_active: this.state.query.is_active
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);

    this.setState({
      query: { ...this.state.query, currentPage: newPage },
    }, () => {
      this.setState({ bankBrands: [] }, () => {
        this.updateUrl(trimmedQuery)
        this.props.getTKT1BankBrands(apiQuery);
        localStorage.setItem('tkt1_bank_brand_query', JSON.stringify(trimmedQuery));
      })
    })
  }

  renderSearchFilter = () => {
    return <>
      <Row className="mb-3">
        <Col md="3">
          <InputGroup>
            <InputGroup.Text>Tìm kiếm</InputGroup.Text>
            <Form.Control
              defaultValue=""
              value={this.state.query.search}
              onChange={this.handleChangeSearch}
              onKeyPress={this.handleKeyPress}
              placeholder="Tìm kiếm theo tên ngân hàng, mã ngân hàng, BIN..."
              aria-label="search"
              aria-describedby="basic-addon1"
            />
            {this.state.query.search && (
              <InputGroup.Text
                onClick={this.handleClearSearch}
                style={{
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  borderLeft: 'none'
                }}
                title="Xóa tìm kiếm"
              >
                <FaTimes size={12} />
              </InputGroup.Text>
            )}
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Trạng thái</InputGroup.Text>
            <Form.Select
              value={this.state.query.is_active}
              onChange={this.handleActiveStatusChange}
            >
              <option value="">Tất cả</option>
              <option value="true">Hoạt động</option>
              <option value="false">Không hoạt động</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Sắp xếp</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortBy}
              onChange={this.handleSelectSort}
            >
              <option value="priority_order">Thứ tự ưu tiên</option>
              <option value="created_at">Ngày tạo</option>
              <option value="updated_at">Ngày cập nhật</option>
              <option value="bank_name">Tên ngân hàng</option>
              <option value="bank_code">Mã ngân hàng</option>
              <option value="bin">BIN</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Thứ tự</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortOrder}
              onChange={this.handleSelectSortOrder}
            >
              <option value="-1">Giảm dần</option>
              <option value="1">Tăng dần</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="3" className="d-flex align-items-center">
          <Button
            className="btn-fill btn"
            type="submit"
            variant="primary"
            onClick={this.handleSubmit}
          >
            Tìm kiếm
          </Button>
        </Col>
      </Row>
    </>
  }

  renderBankBrandTable = () => {
    const { bankBrands } = this.props;
    const { showColumns, columnWidths } = this.state;
    
    const safeBankBrands = Array.isArray(bankBrands) ? bankBrands.filter(brand => brand != null && typeof brand === 'object') : [];
    
    if (!safeBankBrands || safeBankBrands.length === 0) {
      return (
        <Table striped bordered hover style={{ tableLayout: 'fixed' }}>
          <thead>
            <tr>
              <th style={{ width: '60px' }}>STT</th>
              {showColumns.logo && <th style={{ width: `${columnWidths.logo}px`, position: 'relative' }}>
                Logo
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'logo')}
                />
              </th>}
              {showColumns.bank_name && <th style={{ width: `${columnWidths.bank_name}px`, position: 'relative' }}>
                Tên ngân hàng
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'bank_name')}
                />
              </th>}
              {showColumns.bank_code && <th style={{ width: `${columnWidths.bank_code}px`, position: 'relative' }}>
                Mã ngân hàng
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'bank_code')}
                />
              </th>}
              {showColumns.bin && <th style={{ width: `${columnWidths.bin}px`, position: 'relative' }}>
                BIN
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'bin')}
                />
              </th>}
              {showColumns.short_name && <th style={{ width: `${columnWidths.short_name}px`, position: 'relative' }}>
                Tên viết tắt
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'short_name')}
                />
              </th>}
              {showColumns.vietnamese_name && <th style={{ width: `${columnWidths.vietnamese_name}px`, position: 'relative' }}>
                Tên tiếng Việt
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'vietnamese_name')}
                />
              </th>}
              {showColumns.english_name && <th style={{ width: `${columnWidths.english_name}px`, position: 'relative' }}>
                Tên tiếng Anh
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'english_name')}
                />
              </th>}
              {showColumns.swift_code && <th style={{ width: `${columnWidths.swift_code}px`, position: 'relative' }}>
                Mã SWIFT
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'swift_code')}
                />
              </th>}
              {showColumns.can_register_online && <th style={{ width: `${columnWidths.can_register_online}px`, position: 'relative' }}>
                Có thể đăng ký online
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'can_register_online')}
                />
              </th>}
              {showColumns.visa_card_cost && <th style={{ width: `${columnWidths.visa_card_cost}px`, position: 'relative' }}>
                Chi phí thẻ VISA
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'visa_card_cost')}
                />
              </th>}
              {showColumns.register_note && <th style={{ width: `${columnWidths.register_note}px`, position: 'relative' }}>
                Ghi chú đăng ký
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'register_note')}
                />
              </th>}
              {showColumns.etsy_note && <th style={{ width: `${columnWidths.etsy_note}px`, position: 'relative' }}>
                Ghi chú Etsy
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'etsy_note')}
                />
              </th>}
              {showColumns.is_support_etsy && <th style={{ width: `${columnWidths.is_support_etsy}px`, position: 'relative' }}>
                Hỗ trợ Etsy
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'is_support_etsy')}
                />
              </th>}
              {showColumns.max_banks && <th style={{ width: `${columnWidths.max_banks}px`, position: 'relative' }}>
                Số bank tối đa
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'max_banks')}
                />
              </th>}
              {showColumns.max_visa_debit_cards && <th style={{ width: `${columnWidths.max_visa_debit_cards}px`, position: 'relative' }}>
                Số thẻ VISA debit tối đa
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'max_visa_debit_cards')}
                />
              </th>}
              {showColumns.contact_person && <th style={{ width: `${columnWidths.contact_person}px`, position: 'relative' }}>
                Đầu mối contact
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'contact_person')}
                />
              </th>}
              {showColumns.priority_order && <th style={{ width: `${columnWidths.priority_order}px`, position: 'relative' }}>
                Thứ tự ưu tiên
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'priority_order')}
                />
              </th>}
              {showColumns.is_active && <th style={{ width: `${columnWidths.is_active}px`, position: 'relative' }}>
                Trạng thái
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'is_active')}
                />
              </th>}
              {showColumns.created_at && <th style={{ width: `${columnWidths.created_at}px`, position: 'relative' }}>
                Ngày tạo
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'created_at')}
                />
              </th>}
              <th style={{ width: `${columnWidths.actions}px` }}>Thao tác</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={Object.values(showColumns).filter(Boolean).length + 2} className="text-center">
                {this.state.loading ? 'Đang tải...' : 'Không có dữ liệu'}
              </td>
            </tr>
          </tbody>
        </Table>
      );
    }
    
    return (
      <Table striped bordered hover style={{ tableLayout: 'fixed' }}>
        <thead>
          <tr>
            <th style={{ width: '60px' }}>STT</th>
            {showColumns.logo && <th style={{ width: `${columnWidths.logo}px`, position: 'relative' }}>
              Logo
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'logo')}
                style={{
                  position: 'absolute',
                  right: 0,
                  top: 0,
                  width: '4px',
                  height: '100%',
                  cursor: 'col-resize',
                  backgroundColor: '#dee2e6',
                  zIndex: 1
                }}
              />
            </th>}
            {showColumns.bank_name && <th style={{ width: `${columnWidths.bank_name}px`, position: 'relative' }}>
              Tên ngân hàng
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'bank_name')}
                style={{
                  position: 'absolute',
                  right: 0,
                  top: 0,
                  width: '4px',
                  height: '100%',
                  cursor: 'col-resize',
                  backgroundColor: '#dee2e6',
                  zIndex: 1
                }}
              />
            </th>}
            {showColumns.bank_code && <th style={{ width: `${columnWidths.bank_code}px`, position: 'relative' }}>
              Mã ngân hàng
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'bank_code')}
                style={{
                  position: 'absolute',
                  right: 0,
                  top: 0,
                  width: '4px',
                  height: '100%',
                  cursor: 'col-resize',
                  backgroundColor: '#dee2e6',
                  zIndex: 1
                }}
              />
            </th>}
            {showColumns.bin && <th style={{ width: `${columnWidths.bin}px`, position: 'relative' }}>
              BIN
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'bin')}
                style={{
                  position: 'absolute',
                  right: 0,
                  top: 0,
                  width: '4px',
                  height: '100%',
                  cursor: 'col-resize',
                  backgroundColor: '#dee2e6',
                  zIndex: 1
                }}
              />
            </th>}
            {showColumns.short_name && <th style={{ width: `${columnWidths.short_name}px`, position: 'relative' }}>
              Tên viết tắt
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'short_name')}
                style={{
                  position: 'absolute',
                  right: 0,
                  top: 0,
                  width: '4px',
                  height: '100%',
                  cursor: 'col-resize',
                  backgroundColor: '#dee2e6',
                  zIndex: 1
                }}
              />
            </th>}
            {showColumns.vietnamese_name && <th style={{ width: `${columnWidths.vietnamese_name}px`, position: 'relative' }}>
              Tên tiếng Việt
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'vietnamese_name')}
                style={{
                  position: 'absolute',
                  right: 0,
                  top: 0,
                  width: '4px',
                  height: '100%',
                  cursor: 'col-resize',
                  backgroundColor: '#dee2e6',
                  zIndex: 1
                }}
              />
            </th>}
            {showColumns.english_name && <th style={{ width: `${columnWidths.english_name}px`, position: 'relative' }}>
              Tên tiếng Anh
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'english_name')}
                style={{
                  position: 'absolute',
                  right: 0,
                  top: 0,
                  width: '4px',
                  height: '100%',
                  cursor: 'col-resize',
                  backgroundColor: '#dee2e6',
                  zIndex: 1
                }}
              />
            </th>}
            {showColumns.swift_code && <th style={{ width: `${columnWidths.swift_code}px`, position: 'relative' }}>
              Mã SWIFT
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'swift_code')}
                style={{
                  position: 'absolute',
                  right: 0,
                  top: 0,
                  width: '4px',
                  height: '100%',
                  cursor: 'col-resize',
                  backgroundColor: '#dee2e6',
                  zIndex: 1
                }}
              />
            </th>}
            {showColumns.can_register_online && <th style={{ width: `${columnWidths.can_register_online}px`, position: 'relative' }}>
              Có thể đăng ký online
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'can_register_online')}
                style={{
                  position: 'absolute',
                  right: 0,
                  top: 0,
                  width: '4px',
                  height: '100%',
                  cursor: 'col-resize',
                  backgroundColor: '#dee2e6',
                  zIndex: 1
                }}
              />
            </th>}
            {showColumns.visa_card_cost && <th style={{ width: `${columnWidths.visa_card_cost}px`, position: 'relative' }}>
              Chi phí thẻ VISA
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'visa_card_cost')}
                style={{
                  position: 'absolute',
                  right: 0,
                  top: 0,
                  width: '4px',
                  height: '100%',
                  cursor: 'col-resize',
                  backgroundColor: '#dee2e6',
                  zIndex: 1
                }}
              />
            </th>}
            {showColumns.register_note && <th style={{ width: `${columnWidths.register_note}px`, position: 'relative' }}>
              Ghi chú đăng ký
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'register_note')}
                style={{
                  position: 'absolute',
                  right: 0,
                  top: 0,
                  width: '4px',
                  height: '100%',
                  cursor: 'col-resize',
                  backgroundColor: '#dee2e6',
                  zIndex: 1
                }}
              />
            </th>}
            {showColumns.etsy_note && <th style={{ width: `${columnWidths.etsy_note}px`, position: 'relative' }}>
              Ghi chú Etsy
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'etsy_note')}
                style={{
                  position: 'absolute',
                  right: 0,
                  top: 0,
                  width: '4px',
                  height: '100%',
                  cursor: 'col-resize',
                  backgroundColor: '#dee2e6',
                  zIndex: 1
                }}
              />
            </th>}
            {showColumns.is_support_etsy && <th style={{ width: `${columnWidths.is_support_etsy}px`, position: 'relative' }}>
              Hỗ trợ Etsy
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'is_support_etsy')}
                style={{
                  position: 'absolute',
                  right: 0,
                  top: 0,
                  width: '4px',
                  height: '100%',
                  cursor: 'col-resize',
                  backgroundColor: '#dee2e6',
                  zIndex: 1
                }}
              />
            </th>}
            {showColumns.max_banks && <th style={{ width: `${columnWidths.max_banks}px`, position: 'relative' }}>
              Số bank tối đa
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'max_banks')}
                style={{
                  position: 'absolute',
                  right: 0,
                  top: 0,
                  width: '4px',
                  height: '100%',
                  cursor: 'col-resize',
                  backgroundColor: '#dee2e6',
                  zIndex: 1
                }}
              />
            </th>}
            {showColumns.max_visa_debit_cards && <th style={{ width: `${columnWidths.max_visa_debit_cards}px`, position: 'relative' }}>
              Số thẻ VISA debit tối đa
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'max_visa_debit_cards')}
                style={{
                  position: 'absolute',
                  right: 0,
                  top: 0,
                  width: '4px',
                  height: '100%',
                  cursor: 'col-resize',
                  backgroundColor: '#dee2e6',
                  zIndex: 1
                }}
              />
            </th>}
            {showColumns.contact_person && <th style={{ width: `${columnWidths.contact_person}px`, position: 'relative' }}>
              Đầu mối contact
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'contact_person')}
                style={{
                  position: 'absolute',
                  right: 0,
                  top: 0,
                  width: '4px',
                  height: '100%',
                  cursor: 'col-resize',
                  backgroundColor: '#dee2e6',
                  zIndex: 1
                }}
              />
            </th>}
            {showColumns.is_active && <th style={{ width: `${columnWidths.is_active}px`, position: 'relative' }}>
              Trạng thái
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'is_active')}
                style={{
                  position: 'absolute',
                  right: 0,
                  top: 0,
                  width: '4px',
                  height: '100%',
                  cursor: 'col-resize',
                  backgroundColor: '#dee2e6',
                  zIndex: 1
                }}
              />
            </th>}
            {showColumns.created_at && <th style={{ width: `${columnWidths.created_at}px`, position: 'relative' }}>
              Ngày tạo
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'created_at')}
                style={{
                  position: 'absolute',
                  right: 0,
                  top: 0,
                  width: '4px',
                  height: '100%',
                  cursor: 'col-resize',
                  backgroundColor: '#dee2e6',
                  zIndex: 1
                }}
              />
            </th>}
            <th style={{ width: `${columnWidths.actions}px` }}>Thao tác</th>
          </tr>
        </thead>
        <tbody>
          {safeBankBrands.map((brand, index) => {
            if (!brand || typeof brand !== 'object') return null;
              
              return (
                <tr key={brand._id || index}>
                  <td>{(this.state.query.currentPage - 1) * this.state.query.itemsPerPage + index + 1}</td>
                  {showColumns.logo && (
                    <td className="text-center">
                      {brand.logo ? (
                        <Image 
                          src={brand.logo} 
                          alt={brand.logo_alt_text || brand.bank_name || 'Bank Logo'} 
                          style={{ 
                            width: '80px', 
                            height: '50px', 
                            objectFit: 'contain',
                            borderRadius: '4px'
                          }}
                          title={brand.bank_name || 'Bank Logo'}
                        />
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.bank_name && (
                    <td>
                      <div className="fw-bold">{brand.bank_name || '-'}</div>
                    </td>
                  )}
                  {showColumns.bank_code && (
                    <td>
                      {brand.bank_code ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>{brand.bank_code}</Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(brand.bank_code)}
                            title="Copy bank code"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.bin && (
                    <td>{brand.bin || '-'}</td>
                  )}
                  {showColumns.short_name && (
                    <td>{brand.short_name || '-'}</td>
                  )}
                  {showColumns.vietnamese_name && (
                    <td>{brand.vietnamese_name || '-'}</td>
                  )}
                  {showColumns.english_name && (
                    <td>
                      {brand.english_name ? (
                        <div className="d-flex align-items-center gap-2">
                          <span>{brand.english_name}</span>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(brand.english_name)}
                            title="Copy English name"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.swift_code && (
                    <td>
                      {brand.swift_code ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge bg="warning" style={{ fontSize: '0.9em', padding: '6px 10px' }}>{brand.swift_code}</Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(brand.swift_code)}
                            title="Copy SWIFT code"
                          />
                        </div>
                      ) : (
                        <div className="d-flex align-items-center gap-2">
                          <span>-</span>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard('')}
                            title="Copy SWIFT code"
                          />
                        </div>
                      )}
                    </td>
                  )}
                  {showColumns.can_register_online && (
                    <td>
                      {brand.can_register_online ? (
                        <div style={{ 
                          maxWidth: '200px', 
                          wordWrap: 'break-word',
                          whiteSpace: 'pre-wrap',
                          lineHeight: '1.4'
                        }}>
                          {brand.can_register_online}
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.visa_card_cost && (
                    <td>
                      {brand.visa_card_cost ? (
                        <div style={{ 
                          maxWidth: '200px', 
                          wordWrap: 'break-word',
                          whiteSpace: 'pre-wrap',
                          lineHeight: '1.4'
                        }}>
                          {brand.visa_card_cost}
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.register_note && (
                    <td>
                      {brand.register_note ? (
                        <div style={{ 
                          maxWidth: '200px', 
                          wordWrap: 'break-word',
                          whiteSpace: 'pre-wrap',
                          lineHeight: '1.4'
                        }}>
                          {brand.register_note}
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.etsy_note && (
                    <td>
                      {brand.etsy_note ? (
                        <div style={{ 
                          maxWidth: '200px', 
                          wordWrap: 'break-word',
                          whiteSpace: 'pre-wrap',
                          lineHeight: '1.4'
                        }}>
                          {brand.etsy_note}
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.is_support_etsy && (
                    <td>
                      <Badge 
                        bg={brand.is_support_etsy ? 'success' : 'danger'} 
                        style={{ fontSize: '0.8em', padding: '4px 8px' }}
                      >
                        {brand.is_support_etsy ? 'Có' : 'Không'}
                      </Badge>
                    </td>
                  )}
                  {showColumns.max_banks && (
                    <td>{brand.max_banks || '-'}</td>
                  )}
                  {showColumns.max_visa_debit_cards && (
                    <td>{brand.max_visa_debit_cards || '-'}</td>
                  )}
                  {showColumns.contact_person && (
                    <td>
                      {brand.contact_person ? (
                        <div style={{ 
                          maxWidth: '200px', 
                          wordWrap: 'break-word',
                          whiteSpace: 'pre-wrap',
                          lineHeight: '1.4'
                        }}>
                          {brand.contact_person}
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.priority_order && (
                    <td>
                      {brand.priority_order ? (
                        <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                          {brand.priority_order}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.is_active && (
                    <td>
                      <Badge 
                        bg={brand.is_active ? 'success' : 'danger'} 
                        style={{ fontSize: '0.8em', padding: '4px 8px' }}
                      >
                        {brand.is_active ? 'Hoạt động' : 'Không hoạt động'}
                      </Badge>
                    </td>
                  )}
                  {showColumns.created_at && (
                    <td>{brand.created_at ? new Date(brand.created_at).toLocaleDateString('vi-VN') : '-'}</td>
                  )}
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <FaEye 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d'
                        }}
                        title="Xem thông tin"
                        onClick={() => this.handleViewClick(brand)}
                      />
                      <FaEdit 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d'
                        }}
                        title="Chỉnh sửa"
                        onClick={() => this.handleEditClick(brand)}
                      />
                    </div>
                  </td>
                </tr>
              );
            })
          }
        </tbody>
      </Table>
    );
  }

  render() {
    return (
      <>
        <style>
          {`
            .resize-handle {
              transition: all 0.2s ease;
              opacity: 0.3;
              background-color: #dee2e6;
            }
            .resize-handle:hover {
              background-color: #007bff !important;
              opacity: 1;
              width: 6px !important;
            }
            .resize-handle:active {
              background-color: #0056b3 !important;
              opacity: 1;
              width: 6px !important;
            }
            .table-resizing {
              user-select: none;
              cursor: col-resize !important;
            }
            .table-resizing * {
              pointer-events: none;
            }
            .table-resizing .resize-handle {
              pointer-events: auto;
            }
            th:hover .resize-handle {
              opacity: 0.7;
            }
            th {
              position: relative;
            }
            th .resize-handle {
              position: absolute;
              right: 0;
              top: 0;
              width: 4px;
              height: 100%;
              cursor: col-resize;
              z-index: 1;
            }
            .sticky-table {
              position: relative;
              max-height: 70vh;
              overflow-y: auto;
              border: 1px solid #dee2e6;
              border-radius: 0.375rem;
            }
            .sticky-table thead th {
              position: sticky;
              top: 0;
              background-color: #f8f9fa !important;
              z-index: 10;
              border-bottom: 2px solid #dee2e6;
              box-shadow: 0 2px 4px rgba(0,0,0,0.1);
            }
            .sticky-table thead th:first-child {
              z-index: 11;
            }
            .sticky-table thead {
              position: sticky;
              top: 0;
              z-index: 10;
            }
          `}
        </style>
        <Container fluid className={this.state.isResizing ? 'table-resizing' : ''}>
          <Row className="mb-4">
            <Col>
              <h2 className="text-primary">
                TKT1 Bank Brand
              </h2>
            </Col>
            <Col className="text-end" md="auto">
              <Button
                variant="success"
                size="sm"
                onClick={this.handleCreateClick}
                title="Thêm ngân hàng mới"
              >
                <FaPlus /> Thêm mới
              </Button>
            </Col>
          </Row>
          {this.renderSearchFilter()}
          <Row>
            <Col>
              <h5 className="d-inline-block">
                <b>Tìm thấy <span className='text-danger'>{this.props.totalCount}</span> bản ghi:</b>
              </h5>
            </Col>
            <Col className="text-end text-nowrap" md="auto">
              <div className="d-inline-flex align-items-center flex-nowrap">
                <Button 
                  variant="secondary" 
                  size="sm"
                  className="me-2"
                  onClick={() => this.setState({ showConfigModal: true })}
                >
                  <i className="fas fa-cog"></i> Cấu hình hiển thị
                </Button>
                <div className="d-inline-block ms-3">
                  <span className="me-2">Số bản ghi/trang:</span>
                  <Form.Select
                    size="sm"
                    value={this.state.query.itemsPerPage}
                    onChange={this.handleChangeItemsPerPage}
                    style={{ width: '100px', display: 'inline-block' }}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </Form.Select>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="sticky-table">
                {this.renderBankBrandTable()}
              </div>
            </Col>
          </Row>
        </Container>
        <Pagination 
          totalItems={this.props.totalCount} 
          itemsPerPage={this.state.query.itemsPerPage} 
          itemOffset={(this.state.query.currentPage - 1) * this.state.query.itemsPerPage} 
          updatePage={this.updatePage} 
        />

        {/* Configuration Modal */}
        <Modal show={this.state.showConfigModal} onHide={() => this.setState({ showConfigModal: false })}>
          <Modal.Header closeButton>
            <Modal.Title>Cấu hình hiển thị</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <div className="mb-3">
                <h6>Hiển thị cột</h6>
                {Object.entries(this.state.showColumns || {}).map(([column, isVisible]) => {
    const columnLabels = {
      logo: 'Logo',
      bank_name: 'Tên ngân hàng',
      bank_code: 'Mã ngân hàng',
      bin: 'BIN',
      short_name: 'Tên viết tắt',
      vietnamese_name: 'Tên tiếng Việt',
      english_name: 'Tên tiếng Anh',
      swift_code: 'Mã SWIFT',
      can_register_online: 'Có thể đăng ký online',
      visa_card_cost: 'Chi phí thẻ VISA',
      register_note: 'Ghi chú đăng ký',
      etsy_note: 'Ghi chú Etsy',
      is_support_etsy: 'Hỗ trợ Etsy',
      max_banks: 'Số bank tối đa',
      max_visa_debit_cards: 'Số thẻ VISA debit tối đa',
      contact_person: 'Đầu mối contact',
      priority_order: 'Thứ tự ưu tiên',
      is_active: 'Trạng thái',
      created_at: 'Ngày tạo'
    };
                  
                  return (
                    <Form.Check
                      key={column}
                      type="switch"
                      id={`column-${column}`}
                      label={columnLabels[column] || column}
                      checked={isVisible}
                      onChange={() => this.handleColumnToggle(column)}
                      className="mb-2"
                    />
                  );
                })}
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="warning" onClick={this.resetColumnWidths} className="me-2">
              <i className="fas fa-undo me-1"></i>
              Reset độ rộng cột
            </Button>
            <Button variant="secondary" onClick={() => this.setState({ showConfigModal: false })}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* View Modal */}
        <Modal show={this.state.showViewModal} onHide={this.handleCloseViewModal} size="xl">
          <Modal.Header closeButton className="bg-primary text-white">
            <Modal.Title>
              <i className="fas fa-university me-2"></i>
              Thông tin ngân hàng
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-0">
            {this.state.selectedBankBrand && (
              <div>
                {/* Header with Logo and Basic Info */}
                <div className="bg-light p-4 border-bottom">
                  <Row className="align-items-center">
                    <Col md="3" className="text-center">
                      {this.state.selectedBankBrand.logo ? (
                        <Image 
                          src={this.state.selectedBankBrand.logo} 
                          alt={this.state.selectedBankBrand.logo_alt_text || this.state.selectedBankBrand.bank_name} 
                          style={{ 
                            width: '240px', 
                            height: '120px',
                            objectFit: 'contain'
                          }}
                          className="border rounded p-3 bg-white"
                        />
                      ) : (
                        <div className="border rounded p-4 bg-white text-muted">
                          <i className="fas fa-university fa-3x"></i>
                          <div className="mt-2">Không có logo</div>
                        </div>
                      )}
                    </Col>
                    <Col md="9">
                      <h3 className="text-primary mb-2">{this.state.selectedBankBrand.bank_name || '-'}</h3>
                      <div className="d-flex flex-wrap gap-2 mb-2">
                        {this.state.selectedBankBrand.bank_code && (
                          <Badge bg="info" className="fs-6 px-3 py-2">
                            <i className="fas fa-code me-1"></i>
                            {this.state.selectedBankBrand.bank_code}
                          </Badge>
                        )}
                        {this.state.selectedBankBrand.bin && (
                          <Badge bg="secondary" className="fs-6 px-3 py-2">
                            <i className="fas fa-credit-card me-1"></i>
                            BIN: {this.state.selectedBankBrand.bin}
                          </Badge>
                        )}
                        {this.state.selectedBankBrand.is_active !== undefined && (
                          <Badge bg={this.state.selectedBankBrand.is_active ? 'success' : 'danger'} className="fs-6 px-3 py-2">
                            <i className={`fas fa-${this.state.selectedBankBrand.is_active ? 'check' : 'times'}-circle me-1`}></i>
                            {this.state.selectedBankBrand.is_active ? 'Hoạt động' : 'Không hoạt động'}
                          </Badge>
                        )}
                      </div>
                      {this.state.selectedBankBrand.short_name && (
                        <p className="text-muted mb-0">
                          <i className="fas fa-tag me-1"></i>
                          <strong>Tên viết tắt:</strong> {this.state.selectedBankBrand.short_name}
                        </p>
                      )}
                    </Col>
                  </Row>
                </div>

                {/* Main Content */}
                <div className="p-4">
                  <Row>
                    {/* Left Column */}
                    <Col md="6">
                      <Card className="h-100">
                        <Card.Header className="bg-primary text-white" style={{ padding: '0.75rem 1rem' }}>
                          <h5 className="mb-0">
                            <i className="fas fa-info-circle me-2"></i>
                            Thông tin cơ bản
                          </h5>
                        </Card.Header>
                        <Card.Body style={{ padding: '0.75rem 1rem' }}>
                          <div className="mb-3">
                            <div className="row">
                              <div className="col-4">
                                <label className="form-label fw-bold text-primary">
                                  <i className="fas fa-language me-1"></i>
                                  Tên tiếng Việt
                                </label>
                              </div>
                              <div className="col-8">
                                <p className="mb-0">{this.state.selectedBankBrand.vietnamese_name || '-'}</p>
                              </div>
                            </div>
                          </div>
                          <div className="mb-3">
                            <div className="row">
                              <div className="col-4">
                                <label className="form-label fw-bold text-primary">
                                  <i className="fas fa-globe me-1"></i>
                                  Tên tiếng Anh
                                </label>
                              </div>
                              <div className="col-8">
                                <div className="d-flex align-items-center gap-2">
                                  <span>{this.state.selectedBankBrand.english_name || '-'}</span>
                                  {this.state.selectedBankBrand.english_name && (
                                    <FaCopy 
                                      size={12} 
                                      style={{ cursor: 'pointer', color: '#6c757d' }}
                                      onClick={() => this.copyToClipboard(this.state.selectedBankBrand.english_name)}
                                      title="Copy English name"
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mb-3">
                            <div className="row">
                              <div className="col-4">
                                <label className="form-label fw-bold text-primary">
                                  <i className="fas fa-code me-1"></i>
                                  Mã SWIFT
                                </label>
                              </div>
                              <div className="col-8">
                                <div className="d-flex align-items-center gap-2">
                                  <Badge bg="warning" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                                    {this.state.selectedBankBrand.swift_code || '-'}
                                  </Badge>
                                  {this.state.selectedBankBrand.swift_code && (
                                    <FaCopy 
                                      size={12} 
                                      style={{ cursor: 'pointer', color: '#6c757d' }}
                                      onClick={() => this.copyToClipboard(this.state.selectedBankBrand.swift_code)}
                                      title="Copy SWIFT code"
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mb-3">
                            <div className="row">
                              <div className="col-4">
                                <label className="form-label fw-bold text-primary">
                                  <i className="fas fa-user me-1"></i>
                                  Đầu mối contact
                                </label>
                              </div>
                              <div className="col-8">
                                <p className="mb-0" style={{ whiteSpace: 'pre-wrap', lineHeight: '1.4' }}>
                                  {this.state.selectedBankBrand.contact_person || '-'}
                                </p>
                              </div>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>

                    {/* Right Column */}
                    <Col md="6">
                      <Card className="h-100">
                        <Card.Header className="bg-success text-white" style={{ padding: '0.75rem 1rem' }}>
                          <h5 className="mb-0">
                            <i className="fas fa-credit-card me-2"></i>
                            Thông tin dịch vụ
                          </h5>
                        </Card.Header>
                        <Card.Body style={{ padding: '0.75rem 1rem' }}>
                          <div className="mb-3">
                            <div className="row">
                              <div className="col-4">
                                <label className="form-label fw-bold text-success">
                                  <i className="fas fa-laptop me-1"></i>
                                  Có thể đăng ký online
                                </label>
                              </div>
                              <div className="col-8">
                                <p className="mb-0" style={{ whiteSpace: 'pre-wrap', lineHeight: '1.4' }}>
                                  {this.state.selectedBankBrand.can_register_online || '-'}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="mb-3">
                            <div className="row">
                              <div className="col-4">
                                <label className="form-label fw-bold text-success">
                                  <i className="fas fa-dollar-sign me-1"></i>
                                  Chi phí thẻ VISA
                                </label>
                              </div>
                              <div className="col-8">
                                <p className="mb-0 text-muted small" style={{ whiteSpace: 'pre-wrap', lineHeight: '1.4' }}>
                                  {this.state.selectedBankBrand.visa_card_cost || '-'}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="mb-3">
                            <div className="row">
                              <div className="col-4">
                                <label className="form-label fw-bold text-success">
                                  <i className="fas fa-building me-1"></i>
                                  Số bank tối đa
                                </label>
                              </div>
                              <div className="col-8">
                                <p className="mb-0">{this.state.selectedBankBrand.max_banks || '-'}</p>
                              </div>
                            </div>
                          </div>
                          <div className="mb-3">
                            <div className="row">
                              <div className="col-4">
                                <label className="form-label fw-bold text-success">
                                  <i className="fas fa-credit-card me-1"></i>
                                  Số thẻ VISA debit tối đa
                                </label>
                              </div>
                              <div className="col-8">
                                <p className="mb-0">{this.state.selectedBankBrand.max_visa_debit_cards || '-'}</p>
                              </div>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>

                  {/* Additional Information */}
                  <Row className="mt-4">
                    <Col>
                      <Card>
                          <Card.Header className="bg-warning text-dark" style={{ padding: '0.75rem 1rem' }}>
                            <h5 className="mb-0">
                              <i className="fas fa-sticky-note me-2"></i>
                              Thông tin bổ sung
                            </h5>
                          </Card.Header>
                          <Card.Body style={{ padding: '0.75rem 1rem' }}>
                            <div className="mb-3">
                              <div className="row">
                                <div className="col-4">
                                  <label className="form-label fw-bold text-warning">
                                    <i className="fas fa-edit me-1"></i>
                                    Ghi chú đăng ký
                                  </label>
                                </div>
                                <div className="col-8">
                                  <p className="mb-0 text-muted small" style={{ whiteSpace: 'pre-wrap', lineHeight: '1.4' }}>
                                    {this.state.selectedBankBrand.register_note || '-'}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="mb-3">
                              <div className="row">
                                <div className="col-4">
                                  <label className="form-label fw-bold text-warning">
                                    <i className="fas fa-shopping-cart me-1"></i>
                                    Ghi chú Etsy
                                  </label>
                                </div>
                                <div className="col-8">
                                  <p className="mb-0 text-muted small" style={{ whiteSpace: 'pre-wrap', lineHeight: '1.4' }}>
                                    {this.state.selectedBankBrand.etsy_note || '-'}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="mb-3">
                              <div className="row">
                                <div className="col-4">
                                  <label className="form-label fw-bold text-warning">
                                    <i className="fas fa-check-circle me-1"></i>
                                    Hỗ trợ Etsy
                                  </label>
                                </div>
                                <div className="col-8">
                                  <Badge 
                                    bg={this.state.selectedBankBrand.is_support_etsy ? 'success' : 'danger'} 
                                    style={{ fontSize: '0.8em', padding: '4px 8px' }}
                                  >
                                    {this.state.selectedBankBrand.is_support_etsy ? 'Có' : 'Không'}
                                  </Badge>
                                </div>
                              </div>
                            </div>
                            {this.state.selectedBankBrand.ninepay_vietinbank_connection && (
                              <div className="mb-3">
                                <div className="row">
                                  <div className="col-4">
                                    <label className="form-label fw-bold text-warning">
                                      <i className="fas fa-link me-1"></i>
                                      Kết nối 9Pay/VietinBank
                                    </label>
                                  </div>
                                  <div className="col-8">
                                    <p className="mb-0 text-muted small">{this.state.selectedBankBrand.ninepay_vietinbank_connection}</p>
                                  </div>
                                </div>
                              </div>
                            )}
                            {this.state.selectedBankBrand.tags && (
                              <div className="mb-3">
                                <div className="row">
                                  <div className="col-4">
                                    <label className="form-label fw-bold text-warning">
                                      <i className="fas fa-tags me-1"></i>
                                      Tags
                                    </label>
                                  </div>
                                  <div className="col-8">
                                    <div>
                                      {this.state.selectedBankBrand.tags.split(',').map((tag, index) => (
                                        <Badge key={index} bg="light" text="dark" className="me-1 mb-1">
                                          {tag.trim()}
                                        </Badge>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {this.state.selectedBankBrand.display_name && (
                              <div className="mb-3">
                                <div className="row">
                                  <div className="col-4">
                                    <label className="form-label fw-bold text-warning">
                                      <i className="fas fa-eye me-1"></i>
                                      Tên hiển thị
                                    </label>
                                  </div>
                                  <div className="col-8">
                                    <p className="mb-0 text-muted small">{this.state.selectedBankBrand.display_name}</p>
                                  </div>
                                </div>
                              </div>
                            )}
                            {this.state.selectedBankBrand.priority_order && (
                              <div className="mb-3">
                                <div className="row">
                                  <div className="col-4">
                                    <label className="form-label fw-bold text-warning">
                                      <i className="fas fa-sort-numeric-up me-1"></i>
                                      Thứ tự ưu tiên
                                    </label>
                                  </div>
                                  <div className="col-8">
                                    <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                                      {this.state.selectedBankBrand.priority_order}
                                    </Badge>
                                  </div>
                                </div>
                              </div>
                            )}
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer className="bg-light">
            <Button variant="secondary" onClick={this.handleCloseViewModal}>
              <i className="fas fa-times me-1"></i>
              Đóng
            </Button>
            <Button variant="primary" onClick={() => {
              this.handleCloseViewModal();
              this.handleEditClick(this.state.selectedBankBrand);
            }}>
              <i className="fas fa-edit me-1"></i>
              Chỉnh sửa
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Modal */}
        <Modal show={this.state.showEditModal} onHide={this.handleCloseEditModal} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fas fa-edit me-2"></i>
              {this.state.isEditMode ? 'Chỉnh sửa ngân hàng' : 'Thêm ngân hàng mới'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Tên ngân hàng *</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.bank_name}
                      onChange={(e) => this.handleFormChange('bank_name', e.target.value)}
                      placeholder="Nhập tên ngân hàng"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Mã ngân hàng</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.bank_code}
                      onChange={(e) => this.handleFormChange('bank_code', e.target.value)}
                      placeholder="Nhập mã ngân hàng"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>BIN</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.bin}
                      onChange={(e) => this.handleFormChange('bin', e.target.value)}
                      placeholder="Nhập BIN"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Tên viết tắt</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.short_name}
                      onChange={(e) => this.handleFormChange('short_name', e.target.value)}
                      placeholder="Nhập tên viết tắt"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Tên tiếng Việt</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.vietnamese_name}
                      onChange={(e) => this.handleFormChange('vietnamese_name', e.target.value)}
                      placeholder="Nhập tên tiếng Việt"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Tên tiếng Anh</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.english_name}
                      onChange={(e) => this.handleFormChange('english_name', e.target.value)}
                      placeholder="Nhập tên tiếng Anh"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Mã SWIFT</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.swift_code}
                      onChange={(e) => this.handleFormChange('swift_code', e.target.value)}
                      placeholder="Nhập mã SWIFT"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Đầu mối contact</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.contact_person}
                      onChange={(e) => this.handleFormChange('contact_person', e.target.value)}
                      placeholder="Nhập đầu mối contact"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Logo URL</Form.Label>
                    <Form.Control
                      type="url"
                      value={this.state.editFormData.logo}
                      onChange={(e) => this.handleFormChange('logo', e.target.value)}
                      placeholder="Nhập URL logo"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Alt text cho logo</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.logo_alt_text}
                      onChange={(e) => this.handleFormChange('logo_alt_text', e.target.value)}
                      placeholder="Nhập alt text cho logo"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Có thể đăng ký online</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={this.state.editFormData.can_register_online}
                      onChange={(e) => this.handleFormChange('can_register_online', e.target.value)}
                      placeholder="Nhập thông tin đăng ký online"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Chi phí thẻ VISA</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={this.state.editFormData.visa_card_cost}
                      onChange={(e) => this.handleFormChange('visa_card_cost', e.target.value)}
                      placeholder="Nhập thông tin chi phí thẻ VISA"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Ghi chú đăng ký</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={this.state.editFormData.register_note}
                      onChange={(e) => this.handleFormChange('register_note', e.target.value)}
                      placeholder="Nhập ghi chú đăng ký"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Ghi chú Etsy</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={this.state.editFormData.etsy_note}
                      onChange={(e) => this.handleFormChange('etsy_note', e.target.value)}
                      placeholder="Nhập ghi chú Etsy"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Số bank tối đa</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.max_banks}
                      onChange={(e) => this.handleFormChange('max_banks', e.target.value)}
                      placeholder="Nhập số bank tối đa"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Số thẻ VISA debit tối đa</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.max_visa_debit_cards}
                      onChange={(e) => this.handleFormChange('max_visa_debit_cards', e.target.value)}
                      placeholder="Nhập số thẻ VISA debit tối đa"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Kết nối 9Pay/VietinBank</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.ninepay_vietinbank_connection}
                      onChange={(e) => this.handleFormChange('ninepay_vietinbank_connection', e.target.value)}
                      placeholder="Nhập thông tin kết nối"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Tags</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.tags}
                      onChange={(e) => this.handleFormChange('tags', e.target.value)}
                      placeholder="Nhập tags (phân cách bằng dấu phẩy)"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Tên hiển thị</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.display_name}
                      onChange={(e) => this.handleFormChange('display_name', e.target.value)}
                      placeholder="Nhập tên hiển thị"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Thứ tự ưu tiên</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.priority_order}
                      onChange={(e) => this.handleFormChange('priority_order', e.target.value)}
                    >
                      <option value="">Chọn thứ tự ưu tiên</option>
                      {Array.from({ length: 30 }, (_, i) => i + 1).map(num => (
                        <option key={num} value={num}>{num}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Check
                      type="checkbox"
                      label="Hỗ trợ Etsy"
                      checked={this.state.editFormData.is_support_etsy}
                      onChange={(e) => this.handleFormChange('is_support_etsy', e.target.checked)}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Check
                      type="checkbox"
                      label="Hoạt động"
                      checked={this.state.editFormData.is_active}
                      onChange={(e) => this.handleFormChange('is_active', e.target.checked)}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseEditModal}>
              <i className="fas fa-times me-1"></i>
              Hủy
            </Button>
            <Button 
              variant="primary" 
              onClick={this.handleSubmitEdit}
              disabled={this.state.loading}
            >
              {this.state.loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Đang lưu...
                </>
              ) : (
                <>
                  <i className="fas fa-save me-1"></i>
                  Lưu
                </>
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Create Modal - Same as Edit Modal */}
        <Modal show={this.state.showCreateModal} onHide={this.handleCloseCreateModal} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fas fa-plus me-2"></i>
              Thêm ngân hàng mới
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Tên ngân hàng *</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.bank_name}
                      onChange={(e) => this.handleFormChange('bank_name', e.target.value)}
                      placeholder="Nhập tên ngân hàng"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Mã ngân hàng</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.bank_code}
                      onChange={(e) => this.handleFormChange('bank_code', e.target.value)}
                      placeholder="Nhập mã ngân hàng"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>BIN</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.bin}
                      onChange={(e) => this.handleFormChange('bin', e.target.value)}
                      placeholder="Nhập BIN"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Tên viết tắt</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.short_name}
                      onChange={(e) => this.handleFormChange('short_name', e.target.value)}
                      placeholder="Nhập tên viết tắt"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Tên tiếng Việt</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.vietnamese_name}
                      onChange={(e) => this.handleFormChange('vietnamese_name', e.target.value)}
                      placeholder="Nhập tên tiếng Việt"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Tên tiếng Anh</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.english_name}
                      onChange={(e) => this.handleFormChange('english_name', e.target.value)}
                      placeholder="Nhập tên tiếng Anh"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Mã SWIFT</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.swift_code}
                      onChange={(e) => this.handleFormChange('swift_code', e.target.value)}
                      placeholder="Nhập mã SWIFT"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Đầu mối contact</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.contact_person}
                      onChange={(e) => this.handleFormChange('contact_person', e.target.value)}
                      placeholder="Nhập đầu mối contact"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Logo URL</Form.Label>
                    <Form.Control
                      type="url"
                      value={this.state.editFormData.logo}
                      onChange={(e) => this.handleFormChange('logo', e.target.value)}
                      placeholder="Nhập URL logo"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Alt text cho logo</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.logo_alt_text}
                      onChange={(e) => this.handleFormChange('logo_alt_text', e.target.value)}
                      placeholder="Nhập alt text cho logo"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Có thể đăng ký online</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={this.state.editFormData.can_register_online}
                      onChange={(e) => this.handleFormChange('can_register_online', e.target.value)}
                      placeholder="Nhập thông tin đăng ký online"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Chi phí thẻ VISA</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={this.state.editFormData.visa_card_cost}
                      onChange={(e) => this.handleFormChange('visa_card_cost', e.target.value)}
                      placeholder="Nhập thông tin chi phí thẻ VISA"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Ghi chú đăng ký</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={this.state.editFormData.register_note}
                      onChange={(e) => this.handleFormChange('register_note', e.target.value)}
                      placeholder="Nhập ghi chú đăng ký"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Ghi chú Etsy</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={this.state.editFormData.etsy_note}
                      onChange={(e) => this.handleFormChange('etsy_note', e.target.value)}
                      placeholder="Nhập ghi chú Etsy"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Số bank tối đa</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.max_banks}
                      onChange={(e) => this.handleFormChange('max_banks', e.target.value)}
                      placeholder="Nhập số bank tối đa"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Số thẻ VISA debit tối đa</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.max_visa_debit_cards}
                      onChange={(e) => this.handleFormChange('max_visa_debit_cards', e.target.value)}
                      placeholder="Nhập số thẻ VISA debit tối đa"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Kết nối 9Pay/VietinBank</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.ninepay_vietinbank_connection}
                      onChange={(e) => this.handleFormChange('ninepay_vietinbank_connection', e.target.value)}
                      placeholder="Nhập thông tin kết nối"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Tags</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.tags}
                      onChange={(e) => this.handleFormChange('tags', e.target.value)}
                      placeholder="Nhập tags (phân cách bằng dấu phẩy)"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Tên hiển thị</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.display_name}
                      onChange={(e) => this.handleFormChange('display_name', e.target.value)}
                      placeholder="Nhập tên hiển thị"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Thứ tự ưu tiên</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.priority_order}
                      onChange={(e) => this.handleFormChange('priority_order', e.target.value)}
                    >
                      <option value="">Chọn thứ tự ưu tiên</option>
                      {Array.from({ length: 30 }, (_, i) => i + 1).map(num => (
                        <option key={num} value={num}>{num}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Check
                      type="checkbox"
                      label="Hỗ trợ Etsy"
                      checked={this.state.editFormData.is_support_etsy}
                      onChange={(e) => this.handleFormChange('is_support_etsy', e.target.checked)}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Check
                      type="checkbox"
                      label="Hoạt động"
                      checked={this.state.editFormData.is_active}
                      onChange={(e) => this.handleFormChange('is_active', e.target.checked)}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseCreateModal}>
              <i className="fas fa-times me-1"></i>
              Hủy
            </Button>
            <Button 
              variant="primary" 
              onClick={this.handleSubmitEdit}
              disabled={this.state.loading}
            >
              {this.state.loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Đang lưu...
                </>
              ) : (
                <>
                  <i className="fas fa-save me-1"></i>
                  Lưu
                </>
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Toast Notification */}
        <ToastContainer position="top-end" className="p-3">
          <Toast 
            show={this.state.showToast} 
            onClose={() => this.setState({ showToast: false })}
            bg={this.state.toastType === 'success' ? 'success' : 'danger'}
            autohide
            delay={3000}
          >
            <Toast.Header>
              <i className={`fas fa-${this.state.toastType === 'success' ? 'check-circle' : 'exclamation-triangle'} me-2`}></i>
              <strong className="me-auto">
                {this.state.toastType === 'success' ? 'Thành công' : 'Lỗi'}
              </strong>
            </Toast.Header>
            <Toast.Body className="text-white">
              {this.state.toastMessage}
            </Toast.Body>
          </Toast>
        </ToastContainer>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    bankBrands: state.tkt1BankBrandReducer.bankBrands,
    totalCount: state.tkt1BankBrandReducer.totalCount
  };
};

export default connect(mapStateToProps, { 
  getTKT1BankBrands,
  updateTKT1BankBrand,
  createTKT1BankBrand
})(TKT1BankBrand);
